import React from 'react';
import { LayoutGrid, Users, Home } from 'lucide-react';
interface MainTabsProps {
  activeTab?: 'home' | 'clients' | 'properties';
  onTabChange?: (tab: 'home' | 'clients' | 'properties') => void;
}
export function MainTabs({
  activeTab = 'clients',
  onTabChange
}: MainTabsProps) {
  return <div className="flex justify-around items-center px-6 pt-2 pb-0 bg-neutral-bg" data-id="element-71">
      <button onClick={() => onTabChange?.('home')} className={`flex flex-col items-center gap-2 pb-4 px-6 relative transition-all ${activeTab === 'home' ? 'text-primary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-72">
        <div className={`${activeTab === 'home' ? 'bg-gradient-to-br from-accent to-secondary' : ''} ${activeTab === 'home' ? 'p-0.5' : ''} rounded-lg`} data-id="element-73">
          <LayoutGrid className={`w-7 h-7 ${activeTab === 'home' ? 'text-white' : ''}`} strokeWidth={1.5} data-id="element-74" />
        </div>
        <span className="text-sm font-medium" data-id="element-75">Home</span>
        {activeTab === 'home' && <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary rounded-t-full" data-id="element-76" />}
      </button>

      <button onClick={() => onTabChange?.('clients')} className={`flex flex-col items-center gap-2 pb-4 px-6 relative transition-all ${activeTab === 'clients' ? 'text-primary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-77">
        <div className={`${activeTab === 'clients' ? 'bg-gradient-to-br from-accent to-secondary' : ''} ${activeTab === 'clients' ? 'p-0.5' : ''} rounded-lg`} data-id="element-78">
          <Users className={`w-7 h-7 ${activeTab === 'clients' ? 'text-white' : ''}`} strokeWidth={1.5} data-id="element-79" />
        </div>
        <span className="text-sm font-medium" data-id="element-80">Clients</span>
        {activeTab === 'clients' && <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary rounded-t-full" data-id="element-81" />}
      </button>

      <button onClick={() => onTabChange?.('properties')} className={`flex flex-col items-center gap-2 pb-4 px-6 relative transition-all ${activeTab === 'properties' ? 'text-primary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-82">
        <div className={`${activeTab === 'properties' ? 'bg-gradient-to-br from-accent to-secondary' : ''} ${activeTab === 'properties' ? 'p-0.5' : ''} rounded-lg`} data-id="element-83">
          <Home className={`w-7 h-7 ${activeTab === 'properties' ? 'text-white' : ''}`} strokeWidth={1.5} data-id="element-84" />
        </div>
        <span className="text-sm font-medium" data-id="element-85">Properties</span>
        {activeTab === 'properties' && <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary rounded-t-full" data-id="element-86" />}
      </button>
    </div>;
}